<template>

    <v-card>
        <v-card-title>
            <v-icon class="mr-3">mdi-chart-pie</v-icon>Rich Notification Usage
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text style="min-height: 520px;">
            <template v-if="!buildingCharts">
                <v-row class="mt-4 mb-4">
                    <v-col cols="12" class="text-center">
                        <v-btn-toggle v-model="chartTypeButton" @change="buildCharts" class="chart-dataset">
                            <v-btn color="#c42111" value="lastYear">{{ `${thisYear - 1}` }}</v-btn>
                            <v-btn color="#c42111" value="currentYear">{{ `${thisYear}` }}</v-btn>
                            <v-btn color="#c42111" value="twelveMonths">12 Months</v-btn>
                            <v-btn color="#c42111" value="thisMonth">This Month</v-btn>
                            <v-btn color="#c42111" value="last30days">Last 30 Days</v-btn>
                            <v-btn color="#c42111" value="thisWeek">This Week</v-btn>
                        </v-btn-toggle>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" md="4">
                        <div>
                            <highcharts :options="quotaChartOptions"></highcharts>
                        </div>
                    </v-col>

                    <v-col cols="12" md="8">
                        <div style="position: relative;">
                            <highcharts :options="monthChartOptions"></highcharts>
                            <v-btn-toggle light v-model="chartStyleButton" @change="buildCharts" class="chart-style" rounded>
                                <v-btn color="#ffffff" value="column"><v-icon color="#c42111">mdi-chart-bar</v-icon></v-btn>
                                <v-btn color="#ffffff" value="line"><v-icon color="#c42111">mdi-chart-line</v-icon></v-btn>
                            </v-btn-toggle>
                        </div>
                    </v-col>
                </v-row>
            </template>
            <span class="building-charts-text" v-if="!gettingData && buildingCharts">
                Building charts...
                <v-icon large>fas fa-spinner fa-spin</v-icon>
            </span>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
            <div class="flex-grow-1"></div>
            <v-btn text @click="$emit('close')">Close</v-btn>
        </v-card-actions>
    </v-card>

</template>

<script>
export default {
    name: 'CloudUsage',
    props: [],
    data: () => ({
        quotaChartOptions: null,
        monthChartOptions: null,
        chartColors: {
            emailColor: '#F74361',
            smsColor: '#E1F62F',
            telegramColor: '#7CB5EC',
            whatsappColor: '#90ED7D',
            teamsColor: '#5255A9'
        },
        chartTypeButton: 'currentYear',
        thisYear: null,
        chartStyleButton: 'column',
        chartData: null,
        usageData: null,
        processDataWorker: null,
        buildingCharts: true,
        gettingData: true
    }),

    computed: {
    },

    methods: {
        getUsageData: function() {
            let route = (TELSA.apiHost + "pagingrules/cloudusage");
            TELSA.loading(true);
            return this.$http.post(route, {args: {customer: this.$store.state.batchConfig.licensee}}).then(response => {
                let result = response.body;
                this.setupWebWorker();
                this.usageData = result;
                this.chartData = {
                    usageData: this.usageData,
                    thisYear: this.thisYear,
                    chartColors: this.chartColors,
                    chartTypeButton: this.chartTypeButton,
                    chartStyleButton: this.chartStyleButton,
                }
                this.gettingData = false;
                TELSA.loading(false);
                this.buildCharts();
            });
        },

        buildCharts: function() {
            this.chartData.chartTypeButton = this.chartTypeButton;
            this.chartData.chartStyleButton = this.chartStyleButton;
            this.buildingCharts = true;
            this.processDataWorker.postMessage(this.chartData);
        },

        handleWebWorkerResponse: function(event) {
            this.buildingCharts = false;
            this.quotaChartOptions = event.data.quotaChartOptions;
            this.monthChartOptions = event.data.monthChartOptions
        },

        setupWebWorker: function() {
            this.processDataWorker = new Worker("@/components/PagingRules/ProcessCloudUsageWorker", { type: 'module' });
            this.processDataWorker.onmessage = this.handleWebWorkerResponse;
        }
    },

    watch: {
    },

    created() {
        this.thisYear = TELSA.moment.tz(this.$store.state.batchConfig.timezone).year();
    },

    mounted() {
        this.getUsageData();
    },

    destroyed() {
        this.processDataWorker.terminate();
    }
};
</script>

<style scoped>

    .data-title {
        font-size: 2em;
    }

    @media(max-width: 800px) {
        .chart-dataset .v-btn{
            height: 35px !important;
            padding: 8px !important;
        }
    }

    .chart-style {
        position: absolute;
        top: 0px;
        right: 10px;
    }

    .chart-style .v-btn {
        height: 35px !important;
        padding: 8px !important;
    }

    .building-charts-text {
        position: relative;
        display: block;
        text-align: center;
        font-size: 38px;
        top: 200px;
    }

    .building-charts-text i {
        vertical-align: baseline;
    }

</style>

